import { Navigate, Outlet, Route, Routes } from "react-router-dom";

import SidebarLayout from "components/SidebarLayout";
import NotFoundItem from "routes/404/NotFoundItem";
import CampaignFormPage from "routes/ui_sandbox/pages/CampaignFormPage";
import ComponentsPage from "routes/ui_sandbox/pages/ComponentsPage";
import ContactEmailFormPage from "routes/ui_sandbox/pages/ContactEmailFormPage";
import ContactFormPage from "routes/ui_sandbox/pages/ContactFormPage";
import UiSandboxSidebar from "routes/ui_sandbox/UiSandboxSidebar";

// Mounted at `ui-sandbox/*`, so paths here are relative to /ui-sandbox. Each
// new sandbox page adds a route here and an item in UiSandboxSidebar.
export default function UiSandboxRouter() {
  return (
    <Routes>
      <Route
        element={
          <SidebarLayout
            sidebar={<UiSandboxSidebar />}
            content={
              // relative contains absolutely positioned descendants, such as
              // sr-only labels, which otherwise stretch the app's <main>.
              <div className="tw:relative tw:flex tw:flex-col tw:gap-4">
                <Outlet />
              </div>
            }
            mobileMenuLabel="Sandbox Navigation"
          />
        }
      >
        <Route index element={<Navigate to="components" replace />} />
        <Route path="components" element={<ComponentsPage />} />
        <Route path="forms/contact" element={<ContactFormPage />} />
        <Route path="forms/campaign" element={<CampaignFormPage />} />
        <Route path="forms/contact-email" element={<ContactEmailFormPage />} />
        <Route path="*" element={<NotFoundItem />} />
      </Route>
    </Routes>
  );
}
